import React, { FC } from 'react';
import classes from './UserProfileTable.module.scss';
import 'moment/locale/ru';
import { ILoginData } from '../../types/loginData';

type Props = {
  loginData: ILoginData;
};

export const UserProfileTable: FC<Props> = ({ loginData }) => {
  return (
    <div className={classes.userAuthInfo}>
      <table className={classes.auth_table}>
        <thead>
          <tr>
            <th>Дата и время входа</th>
            <th>Статус</th>
            <th>IP-адрес</th>
            <th>Клиент</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td width="26%">{loginData.entryAt}</td>
            <td width="27%">{loginData.status}</td>
            <td width="27%">{loginData.ip}</td>
            <td width="20%">{loginData.client}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
